import { makeStyles } from '@material-ui/core';
import { lighten } from '@material-ui/core/styles';

const BUTTON_WIDTH = 125;

const useStyles = makeStyles(theme => ({
  altBlueButton: {
    minWidth: BUTTON_WIDTH,
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: lighten(theme.palette.primary.light, 0.5),
    },
    '&:disabled': {
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.primary.light,
    },
  },
  button: {
    minWidth: BUTTON_WIDTH,
    paddingTop: 10,
    paddingBottom: 10,
  },
  revokeButton: {
    marginBottom: theme.spacing(),
  },
  copyButton: {
    marginTop: theme.spacing(1.5),
  },
  placeholder: {
    minWidth: BUTTON_WIDTH,
  },
  copyText: theme.mixins.visuallyHidden,
}));

export default useStyles;
